/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentTwinsGroupResponseDto } from './ComponentTwinsGroupResponseDto';
import {
    ComponentTwinsGroupResponseDtoFromJSON,
    ComponentTwinsGroupResponseDtoFromJSONTyped,
    ComponentTwinsGroupResponseDtoToJSON,
    ComponentTwinsGroupResponseDtoToJSONTyped,
} from './ComponentTwinsGroupResponseDto';

/**
 * 
 * @export
 * @interface ListComponentTwinsGroupsResponseDto
 */
export interface ListComponentTwinsGroupsResponseDto {
    /**
     * 
     * @type {Array<ComponentTwinsGroupResponseDto>}
     * @memberof ListComponentTwinsGroupsResponseDto
     */
    data: Array<ComponentTwinsGroupResponseDto>;
}

/**
 * Check if a given object implements the ListComponentTwinsGroupsResponseDto interface.
 */
export function instanceOfListComponentTwinsGroupsResponseDto(value: object): value is ListComponentTwinsGroupsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListComponentTwinsGroupsResponseDtoFromJSON(json: any): ListComponentTwinsGroupsResponseDto {
    return ListComponentTwinsGroupsResponseDtoFromJSONTyped(json, false);
}

export function ListComponentTwinsGroupsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListComponentTwinsGroupsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ComponentTwinsGroupResponseDtoFromJSON)),
    };
}

export function ListComponentTwinsGroupsResponseDtoToJSON(json: any): ListComponentTwinsGroupsResponseDto {
    return ListComponentTwinsGroupsResponseDtoToJSONTyped(json, false);
}

export function ListComponentTwinsGroupsResponseDtoToJSONTyped(value?: ListComponentTwinsGroupsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ComponentTwinsGroupResponseDtoToJSON)),
    };
}

